import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Observable, Subject, Subscription } from "rxjs"
import { ErrorService } from "src/app/error/err.service";
import { ToastService } from "src/app/shared/custom-overlay/toast/toast.service";
import { ToastType } from "src/app/shared/shared.enums";

enum EmitStates {
    Fetchforce = -1,
    Fetch = 1,
    AlreadyFetched = 0
}

enum ResponseStates {
    ResponseDefault = -1,
    RespondedPending = 0
}

export class AlertLongPollingAPIManagement {
    public emitstate: number = EmitStates.Fetchforce;
    private storeData: any = null;
    private requestTimeout: any;
    private refreshInterval: number = 600000;
    private isProgress_: Subject<boolean> = new Subject();
    isProgress$ = this.isProgress_.asObservable();
    private isprogress: boolean = false;
    private stoppolling: boolean = false;
    private emitData: Subject<any> = new Subject();
    private subscription: Subscription = Subscription.EMPTY;
    private timeIntervalState: boolean = false;
    public responsestate: number = ResponseStates.ResponseDefault;
    private maxCount = 0;

    constructor(
        private requestmethod: Function,
        public http: HttpClient,
        private destroyed: Observable<number>,
        private userloggedout: Observable<boolean>,
        private errorservice: ErrorService,
        private url: string,
        private moduleName: string,
        private toastService: ToastService
    ) {
        this.destroyed.subscribe((val: number) => {
            if (!this.isprogress) {
                this.changeEmit(EmitStates.AlreadyFetched);
            } else {
                this.emitstate = EmitStates.AlreadyFetched;
            }
        });
        this.userloggedout.subscribe((val: any) => {
            this.cancelRequest();
            this.clearStoredData();
        });
    }

    toStringify(postData: any) {
        return JSON.stringify(postData)
    }

    headers = new HttpHeaders({ 'content-type': 'application/json' });

    postrequest(requestobj: any) {
        if (!this.isprogress) {
            this.isProgress_.next(true);
            this.responsestate = ResponseStates.RespondedPending;
            this.emitData = new Subject();
            this.stoppolling = false;
//console.log("postrequest", this.storeData)
            if (this.emitstate) {
                this.subscription = this.requestmethod(this.toStringify({ "request_type": "handshake" })).subscribe((dat: any) => {
                    if (dat) {
                        this.startLongPolling({ ...requestobj, "token": dat.token, "request_type": dat.request_type })
                    } else {
//console.log("request returned null")
                        this.errorReset();
                        this.emitData.error({});
                    }
                }, (err: any) => {
                    this.errorReset()
                    this.emitData.error(err);
                })
            } else {
                setTimeout(() => {
                    this.emitData.next(this.storeData);
                    this.isProgress_.next(false);
                    this.isprogress = false;
                    this.responsestate = ResponseStates.ResponseDefault;
                    this.storeData = null;
                    this.changeEmit(1);
                }, 0);
            }
        }
        return this.emitData.asObservable();
    }

    startLongPolling(requestobj: any) {
        this.subscription = this.requestmethod(this.toStringify(requestobj)).subscribe((dat: any) => {
            if (dat) {
                if (dat.isData) {
                    if (this.emitstate) {
                        this.emitData.next(dat.res_obj)
                        this.completeReset();
                        this.responsestate = ResponseStates.ResponseDefault;
                    } else {
                        this.storeData = dat.res_obj;
                        this.completeReset();
                        this.responsestate = ResponseStates.RespondedPending;
                    }
                } else if (dat.isError) {
                    this.showError(dat.error.errmsg, ToastType.failure)
                    this.errorReset();
                    this.errorservice.postOnlineErrors(this.createErrorObject(dat, 1, 1), 1);
                    this.emitData.error(dat);
                } else {
                    this.continuousRequest({ "token": dat.token, "request_type": dat.request_type })
                }
            } else {
//console.log("request returned null")
                this.errorReset();
                this.emitData.error({});
            }

        })
    }

    continuousRequest(requestobj: any) {
        if (this.maxCount < 3 && !this.stoppolling) {
            this.subscription = this.requestmethod(this.toStringify(requestobj)).subscribe((dat: any) => {
                if (dat) {
                    if (dat.isData) {
                        if (this.emitstate) {
                            this.emitData.next(dat.res_obj)
                            this.completeReset();
                            this.responsestate = ResponseStates.ResponseDefault;
                        } else {
                            this.storeData = dat.res_obj;
                            this.completeReset();
                            this.responsestate = ResponseStates.RespondedPending;
                        }
                    } else if (dat.isError) {
                        this.showError(dat.error.errmsg, ToastType.failure)
                        this.errorReset();
                        this.errorservice.postOnlineErrors(this.createErrorObject(dat, 1, 1), 1);
                        this.emitData.error(dat);
                    } else {
                        this.maxCount++;
                        this.continuousRequest({ "token": dat.token, "request_type": dat.request_type })
                    }
                } else {
//console.log("request returned null")
                    this.errorReset();
                    this.emitData.error({});
                }
            })
        } else {
            this.emitData.error({ error: { errmsg: "Server takes long time then expected" } });
            this.maxCount = 0;
            this.errorReset();
            this.showError('Server takes long time then expected', ToastType.failure);
            this.errorservice.postOnlineErrors(this.createErrorObject('Maximum number of api request exceeded', 1, 0), 1);
        }

    }

    completeReset() {
        this.isProgress_.next(false);
        this.isprogress = false;
        this.maxCount = 0;
        if (this.emitstate == EmitStates.Fetchforce) {
            this.emitstate = EmitStates.Fetch
        }
    }

    errorReset() {
        this.emitstate = EmitStates.Fetchforce;
        this.responsestate = ResponseStates.ResponseDefault;
        this.isProgress_.next(false);
        this.isprogress = false;
    }

    showError(errormsg: string, type: string) {
        this.toastService.ShowToaster(this.moduleName + " :" + errormsg, type);
    }

    createErrorObject(val: any, errorState: number, customstate: number) {
        const errobj = this.errorservice.httpobjectBuilder(errorState, customstate, val);
        errobj.url = this.url;
        return errobj;
    }

    getemitstate() {
        return this.emitstate;
    }

    changeEmit(val: number) {
        if (this.emitstate != EmitStates.Fetchforce) {
            this.emitstate = val;
        }
    }

    refresh() {
        this.emitstate = EmitStates.Fetchforce;
        this.isProgress_.next(false);
        this.clearReset();
        this.resetstoreddata();
    }

    resetstoreddata() {
        this.requestTimeout = setTimeout(() => {
            this.timeIntervalState = false;
            this.emitstate = EmitStates.Fetchforce;
        }, this.refreshInterval);
    }

    clearReset() {
        clearTimeout(this.requestTimeout)
    }

    cancelRequest() {
        this.emitstate = EmitStates.Fetchforce;
        this.isProgress_.next(false);
        this.subscription.unsubscribe();
        if (this.isprogress) {
            this.stoppolling = true;
        }
    }

    clearStoredData() {
        this.storeData = null;
    }

    getprogress() {
        return this.isprogress;
    }
}